import { WifiOff } from 'lucide-react';
import { useOfflineStatus } from '@/hooks/use-offline';

interface OfflineIndicatorProps {
  className?: string;
  message?: string;
}

export function OfflineIndicator({
  className = '',
  message = 'You are offline. Some features may be unavailable until you reconnect.',
}: OfflineIndicatorProps) {
  const { isOffline } = useOfflineStatus();

  if (!isOffline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800 ${className}`}
    >
      <WifiOff className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
